import styles from './styles/PlayerBlock.module.scss';
import ProfileImage from 'components/ProfileImage';
import Link from 'components/Link';
import cn from 'classnames';
import TextTruncateComponent from './TextTruncateComponent';

interface PlayerBlockProps {
  player: {
    web_path?: string;
    image?: string;
    first_name?: string;
    jersey_number?: string;
    last_name?: string;
    id: string;
  };
  genderSport: string;
  isSmall?: boolean;
  v2?: boolean;
}

function PlayerBlock({ player, genderSport, isSmall, v2 }: PlayerBlockProps) {
  return (
    <div className={cn(styles.PlayerBlock, { [styles.PlayerBlockSmall]: isSmall, [styles.v2]: v2 })}>
      <Link href={player.web_path}>
        <div>
          <ProfileImage src={player.image} alt={player.first_name} genderSport={genderSport} />
        </div>
        <div className={styles.PlayerBlockInfo}>
          <div className={styles.PlayerBlockJersey}>{player.jersey_number}</div>
          <div className={styles.PlayerBlockName}>
            {v2 ? (
              <TextTruncateComponent
                containerClassName={cn(styles.PlayerBlockFirstName, styles.PlayerBlockLastName)}
                line={1}
                text={`${player.first_name} ${player.last_name}`}
              />
            ) : (
              <>
                <div className={styles.PlayerBlockFirstName}>{player.first_name}</div>
                <div className={styles.PlayerBlockLastName}>{player.last_name}</div>
              </>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
}

export default PlayerBlock;
